const copyLinks = document.querySelectorAll(".js-copy-link");

copyLinks.forEach((copyLink) => {
    copyLink.addEventListener("click", (e) => {
        e.preventDefault();
        const copyContent = copyLink.dataset.copyContent;
        origLinkText = copyLink.innerHTML;

        navigator.clipboard.writeText(copyContent).then(() => {
            copyLink.textContent = "Copied!";

            setTimeout(() => {
                copyLink.innerHTML = origLinkText;
            }, 1000);
        });
    });
});
